module.exports = __webpack_public_path__ + "img/trevor-pro.91e30bba.jpg";